import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { SectionEnum, LabelEnum, groupSelectOptions } from "./types";

export function useListBoxItems({
  SECTIONS,
  filteredItems,
  inputValue,
  existingItemsLabel,
  newItemLabel,
}: {
  SECTIONS: SectionEnum;
  filteredItems: Record<string, any>[];
  inputValue: string;
  existingItemsLabel: string;
  newItemLabel: string;
}) {
  return useMemo(
    () => [
      {
        name: existingItemsLabel.toUpperCase(),
        id: SECTIONS.VALUES,
        children: filteredItems,
      },
      {
        name: newItemLabel.toUpperCase(),
        id: SECTIONS.NEW_VALUE,
        children: [
          {
            id: 0,
            tagValue: `${inputValue} (${newItemLabel})`,
          },
        ],
      },
    ],
    [SECTIONS, filteredItems, inputValue, existingItemsLabel, newItemLabel]
  );
}

export function useGetSectionEnum(option: groupSelectOptions) {
  const TAG_SECTIONS: SectionEnum = {
    NEW_VALUE: "new-tag",
    VALUES: "tags",
  } as const;
  const CHECK_SECTIONS: SectionEnum = {
    NEW_VALUE: "new-check",
    VALUES: "checks",
  } as const;
  if (option === "tag") {
    return TAG_SECTIONS;
  }
  if (option === "check") {
    return CHECK_SECTIONS;
  }
  return TAG_SECTIONS; // default to TAG_SECTIONS for now, eventually it'll be different types
}

export function useGetLabelEnum(option: groupSelectOptions) {
  const { t } = useTranslation();

  const TAG_LABELS: LabelEnum = {
    EXISTING_ITEMS: t("Existing tags"),
    NEW_ITEM: t("New tag"),
    NO_ITEMS_FOUND: t("No tags found"),
    ITEM_ALREADY_SELECTED: t("Tag already selected"),
  } as const;
  const CHECK_LABELS: LabelEnum = {
    EXISTING_ITEMS: t("Existing checks"),
    NEW_ITEM: t("New check"),
    NO_ITEMS_FOUND: t("No checks found"),
    ITEM_ALREADY_SELECTED: t("Check already selected"),
  } as const;
  if (option === "tag") {
    return TAG_LABELS;
  }
  if (option === "check") {
    return CHECK_LABELS;
  }
  return TAG_LABELS; // default to TAG_LABELS for now, eventually it'll be different types
}
